import React from 'react';
import { Input, InputContainer, Label } from './style';

type Props = {
  name: string;
  label: string;
  mask?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: any;
  placeholder: string;
  maxLength?: number;
  type?: string;
  inputWidth?: string;
  colorBorder: string;
  inputMode?: string;
};

function InputCheckout({
  name,
  label,
  mask,
  value,
  onChange,
  placeholder,
  maxLength,
  type,
  inputWidth,
  colorBorder,
  inputMode,
  onFocus,
  onBlur,
}: Props): JSX.Element {
  return (
    <InputContainer>
      <Label htmlFor={name}>{label}</Label>
      <Input
        autoComplete="off"
        type={type}
        mask={mask}
        value={value}
        onChange={onChange}
        id={name}
        name={name}
        placeholder={placeholder}
        maxLength={maxLength}
        inputwidth={inputWidth}
        colorborder={colorBorder}
        required
        inputMode={inputMode}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </InputContainer>
  );
}

export default InputCheckout;
